module.exports = __webpack_public_path__ + "img/no_data_ov.6cc6b47a.jpg";